module.exports = __webpack_public_path__ + "img/scheme-bottom.6f55e481.jpg";